module.exports = __webpack_public_path__ + "media/images/vector-90@2x-18a12814fa8af3a92f951279c550f340.png";